import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/messaging'
import * as React from 'react'
import ReactDOM from 'react-dom'
import { FirestoreProvider } from 'react-firestore'
import { BehaviorSubject } from 'rxjs'
import App from './App'
import { FirebaseContext, ModelContext } from './Ctx'
import './index.css'
import Model from './Model'
// import registerServiceWorker from './registerServiceWorker'

// Add additional services that you want to use

const config = {
	apiKey: 'AIzaSyDWN50Mhn9TmNfcxIuNcgrqh8ui5wyC7Gk',
	authDomain: 'srnky-6f3b9.firebaseapp.com',
	databaseURL: 'https://srnky-6f3b9.firebaseio.com',
	messagingSenderId: '296281278103',
	projectId: 'srnky-6f3b9',
	storageBucket: 'srnky-6f3b9.appspot.com'
}

firebase.initializeApp(config)
if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
	// Additional state parameters can also be passed via URL.
	// This can be used to continue the user's intended action before triggering
	// the sign-in operation.
	// Get the email if available. This should be available if the user completes
	// the flow on the same device where they started it.
	let email = window.localStorage.getItem('emailForSignIn')
	if (!email) {
		// User opened the link on a different device. To prevent session fixation
		// attacks, ask the user to provide the associated email again. For example:
		email = window.prompt('Napiš svůj email pro ověření')
	}
	// The client SDK will parse the code from the link for you.
	firebase
		.auth()
		.signInWithEmailLink(email, window.location.href)
		.then(async result => {
			// Clear email from storage.
			window.localStorage.removeItem('emailForSignIn')

			const srnkaSnap = await firebase
				.firestore()
				.doc(`/srnky/${result.user.email}`)
				.get()

			if (!srnkaSnap.exists) {
				srnkaSnap.ref.set({
					food: 15,
					money: 100
				})
				;(window as any).firstSignIn = true
			}

			// You can access the new user via result.user
			// Additional user info profile not available via:
			// result.additionalUserInfo.profile == null
			// You can check if the user is new or existing:
			// result.additionalUserInfo.isNewUser
			window.history.pushState(null, 'Přihlášená srnka', '/')
		})
		.catch(error => {
			// Some error occurred, you can inspect the code: error.code
			// Common errors could be invalid email and invalid or expired OTPs.
			console.error(error)
		})
}

firebase
	.auth()
	.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
	.then(() => {
		// Existing and future Auth states are now persisted in the current
		// session only. Closing the window would clear any existing state even
		// if a user forgets to sign out.
		// ...
		// New sign-in will be persisted with session persistence.
		// return firebase.auth().signInWithEmailAndPassword(email, password);
	})
	.catch(error => {
		// Handle Errors here.
		console.error(error)
	})

ReactDOM.render(
	<ModelContext.Provider value={new Model(firebase.firestore())}>
		<FirebaseContext.Provider value={firebase}>
			<FirestoreProvider firebase={firebase}>
				<App />
			</FirestoreProvider>
		</FirebaseContext.Provider>
	</ModelContext.Provider>,
	document.getElementById('root')
)
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx